import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import general from "./modules/general.js";
import generalPersist from "./modules/generalPersist.js";
import sidebar from "./modules/sidebar.js";
import yellowBanner from "./modules/yellowBanner.js";
import confirmModal from "./modules/confirmModal.js";
import promo from "./modules/promo.js";
import engagementPromo from "./modules/engagementPromo.js";
import gamesCategory from "./modules/gamesCategory.js";
import crossPromotion from "./modules/crossPromotion.js";
import games from "./modules/games.js";
import selectImage from "./modules/selectImage.js";
import selectEnv from "./modules/selectEnv.js";
import auth from "./modules/auth.js";
import previewMode from "./modules/previewMode.js";

export default createStore({
  state() {
    return {
      msalConfig: {
        auth: {
          clientId: "ddd9df78-61a9-4c95-84ba-b4f11eadea38",
          authority:
            "https://login.microsoftonline.com/7945008c-5c1b-42a9-a1c3-7f3d3642da94/",
        },
        cache: {
          cacheLocation: "localStorage",
        },
      },
      accessToken: "",
    };
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
  },

  plugins: [
    // Set modules that need to have persist state (keep the state even if reload)
    createPersistedState({
      paths: ["selectEnv", "generalPersist", "auth"],
    }),
  ],

  modules: {
    general,
    sidebar,
    yellowBanner,
    confirmModal,
    promo,
    engagementPromo,
    crossPromotion,
    games,
    selectImage,
    selectEnv,
    generalPersist,
    auth,
    gamesCategory,
    previewMode,
  },
});
